import { Heading } from "@/components";
import { cn } from "@/lib/utils";
import {
  FileText,
} from "lucide-react";
import { Header } from "./Header";
import useDistributionMetricsMaintenance from "./useDistributionMetricsMaintenance";
import { METRIC_BEHAVIORS } from "./consts";
import { SquareFootage } from "./SquareFootage";
import { CamWeighingFactor } from "./WeighingFactor";

const DistributionMetricsMaintenance = () => {
  const {
    breadcrumbData,
    metricStatus,
    form,
    isWeighingFactor,
    activeType
  } = useDistributionMetricsMaintenance();

  return (
    <div className="p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="Allocation Metrics Maintenance"
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      <div className={cn("grid grid-cols-1 gap-4 mb-5", isWeighingFactor ? "" : "xl:grid-cols-[minmax(0,1fr)_260px]")}>
        <div className="bg-white rounded-lg px-5 py-5">
          <Header form={form} />
        </div>

        {isWeighingFactor ? <></> : <div className="bg-white rounded-lg p-4">
          <h3 className="text-[14px] font-semibold text-g-500 mb-3">
            Metric Status
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 gap-3">
            {metricStatus.map((status) => (
              <div
                key={status.label}
                className={cn(
                  "border rounded-md p-3 flex items-center gap-3",
                  status.className
                )}
              >
                <span
                  className={cn(
                    "h-8 w-8 rounded-full flex items-center justify-center",
                    status.iconClassName
                  )}
                >
                  <FileText className="h-4 w-4" />
                </span>
                <span className="flex flex-col leading-tight">
                  <span className="text-[12px] font-semibold">
                    {status.label}
                  </span>
                  <span className="text-[12px] font-bold">{status.value}</span>
                </span>
              </div>
            ))}
          </div>
        </div>}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[260px_minmax(0,1fr)] gap-5">
        <div className="bg-white rounded-lg p-5 h-fit">
          <h3 className="text-[16px] font-semibold text-primary mb-6">
            Metric Behaviors
          </h3>
          <div className="flex flex-col gap-4">
            {METRIC_BEHAVIORS.map((behavior) => (
              <div
                key={behavior.title}
                className={cn(
                  "rounded-lg p-5 flex gap-4 min-h-[88px]",
                  behavior.isActive
                    ? "border border-primary bg-primary-300/50 items-start"
                    : "border border-dashed border-g-200 items-center"
                )}
              >
                {!behavior.isActive && (
                  <div className="h-8 w-8 rounded-full bg-primary-300/70 flex items-center justify-center text-primary shrink-0">
                    <FileText className="h-4 w-4" />
                  </div>
                )}
                <div className="min-w-0">
                  <p className="text-[15px] font-semibold text-g-500">
                    {behavior.title}
                  </p>
                  <p className="text-[12px] text-g-400 mt-2">
                    {behavior.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {isWeighingFactor ? <CamWeighingFactor activeType={activeType} /> : <SquareFootage />}
        
      </div>
    </div>
  );
};

export default DistributionMetricsMaintenance;
